import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <section className="max-w-4xl mx-auto px-5 md:px-10 py-24 text-center" data-testid="not-found">
            <p className="bc-label-small">Erreur 404</p>
            <h1 className="font-serif text-5xl sm:text-6xl text-[#D4BC7C] mt-4">Page introuvable</h1>
            <p className="text-[#A0A0A0] mt-6 text-base">
                La page que vous cherchez n'existe pas ou a été déplacée.
            </p>
            <div className="mt-10">
                <Link to="/" className="bc-btn" data-testid="btn-back-home">
                    Retour à l'accueil
                </Link>
            </div>
        </section>
    );
}
